var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCallOfDutyHighlighted(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 53.039,
    height: 59.748,
    viewBox: "0 0 53.039 59.748",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_29454",
    "data-name": "Group 29454",
    transform: "translate(-489 -582.165)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svgexport-7_20_",
    "data-name": "svgexport-7 (20)",
    transform: "translate(489 582.165)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_48766",
    "data-name": "Path 48766",
    d: "M76.459,46.592a.961.961,0,1,1,.9-1.7,11.014,11.014,0,0,1,3.2,2.393,4.54,4.54,0,0,1,1.231,2.987c0,2.811-3.113,5.254-8.148,6.93a60.509,60.509,0,0,1-18.371,2.546A60.5,60.5,0,0,1,36.9,57.2c-5.035-1.676-8.148-4.119-8.148-6.93a4.544,4.544,0,0,1,1.231-2.987,11.015,11.015,0,0,1,3.2-2.393.961.961,0,1,1,.9,1.7,9.161,9.161,0,0,0-2.643,1.949,2.689,2.689,0,0,0-.757,1.73c0,1.89,2.609,3.7,6.824,5.108a58.6,58.6,0,0,0,17.769,2.44,58.606,58.606,0,0,0,17.77-2.44c4.216-1.4,6.823-3.217,6.823-5.107a2.687,2.687,0,0,0-.757-1.73,9.144,9.144,0,0,0-2.643-1.949ZM48.677,43.021a24.169,24.169,0,0,0-6.952,1.915c-1.483.729-2.35,1.52-2.35,2.284,0,1.09,1.634,2.179,4.274,3.058a38.326,38.326,0,0,0,11.618,1.592,38.324,38.324,0,0,0,11.618-1.592c2.641-.88,4.275-1.969,4.275-3.058,0-.764-.866-1.555-2.351-2.284a24.166,24.166,0,0,0-6.951-1.915,35.368,35.368,0,0,1-6.087,4.956.959.959,0,0,1-1.028-.012,35.482,35.482,0,0,1-6.067-4.944ZM55.267,8.5a10.049,10.049,0,1,1-7.107,2.943A10.049,10.049,0,0,1,55.267,8.5Zm5.744,4.306a8.122,8.122,0,1,0,2.379,5.743,8.122,8.122,0,0,0-2.379-5.743ZM49.977,41.6a34.97,34.97,0,0,0,5.29,4.425,35.047,35.047,0,0,0,5.29-4.423A46.03,46.03,0,0,0,71.012,25.761c2.178-5.913,2.527-12.143-.78-17.476a18.044,18.044,0,0,0-2.6-3.245,17.69,17.69,0,0,0-24.732,0,18.044,18.044,0,0,0-2.6,3.245c-3.307,5.333-2.958,11.563-.779,17.476A46.009,46.009,0,0,0,49.977,41.6Z",
    transform: "translate(-28.748 0)",
    fill: "#1a74e2",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_284",
    "data-name": "Ellipse 284",
    cx: 15.884,
    cy: 15.884,
    r: 15.884,
    transform: "translate(10.685 1.444)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_29453",
    "data-name": "Group 29453",
    transform: "translate(-18.225 6)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_50751",
    "data-name": "Path 50751",
    d: "M38.305,20.827a5.757,5.757,0,0,1-.629,1.635h1.873a1.385,1.385,0,0,0,.35-.041,1.611,1.611,0,0,0,1.2-1.1,1.5,1.5,0,0,0,.077-.488V17a.816.816,0,0,0-.813-.813h-.755V15.142c0-1.659-.485-2.943-2.091-3.142h-.531a7.908,7.908,0,0,1,.937,3.142V18.8h0a3.882,3.882,0,0,1,.411,1.626A3.438,3.438,0,0,1,38.305,20.827Z",
    transform: "translate(504.005 575.207)",
    fill: "#90a4ae"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_29452",
    "data-name": "Group 29452",
    transform: "translate(523.224 582.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_50750",
    "data-name": "Path 50750",
    d: "M5.871,20.827A5.757,5.757,0,0,0,6.5,22.462H4.626a1.385,1.385,0,0,1-.35-.041,1.611,1.611,0,0,1-1.2-1.1A1.5,1.5,0,0,1,3,20.835V17a.816.816,0,0,1,.813-.813h.755V15.142c0-1.659.485-2.943,2.091-3.142h.531a7.908,7.908,0,0,0-.937,3.142V18.8h0a3.882,3.882,0,0,0-.411,1.626A3.565,3.565,0,0,0,5.871,20.827Z",
    transform: "translate(-3 -7.294)",
    fill: "#90a4ae"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50752",
    "data-name": "Path 50752",
    d: "M24.683,10.724v3.66h0a15.7,15.7,0,0,0-1.234-2.033c-.825-1.22-3.467-2.571-6.608-2.571-3.639,0-5.778,1.626-6.6,2.846A15.759,15.759,0,0,0,9,14.658V10.724a7.611,7.611,0,0,1,1.577-4.636,7.9,7.9,0,0,1,12.531,0,7.72,7.72,0,0,1,.9,1.5A7.521,7.521,0,0,1,24.683,10.724Z",
    transform: "translate(-5.863 -2.998)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50753",
    "data-name": "Path 50753",
    d: "M24.307,19.11a15.74,15.74,0,0,0-1.251-2.042,7.877,7.877,0,0,1-.9-3.13A1.047,1.047,0,0,0,21.12,13l-9.5,0a1.046,1.046,0,0,0-1.046.951,6.828,6.828,0,0,1-.9,3.117A15.81,15.81,0,0,0,8.422,19.11,3.825,3.825,0,0,0,8,20.744a4.694,4.694,0,0,0,.514,2,2.719,2.719,0,0,0,2.413,1.674c1.581,0,1.652,1.866,1.748,3.129.029.413.029.756.029.956,0,.717,3.66.713,3.66.713s3.66,0,3.66-.713c0-.2,0-.543.029-.956.1-1.262.167-3.129,1.748-3.129a2.719,2.719,0,0,0,2.413-1.674,4.7,4.7,0,0,0,.514-2A3.825,3.825,0,0,0,24.307,19.11Z",
    transform: "translate(-5.387 -7.771)",
    fill: "#d7ccc8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50754",
    "data-name": "Path 50754",
    d: "M24.128,33.524a.576.576,0,0,1-.626.6c-.491,0-.849-.819-.938-1.164,0,.431-.358,1.164-.938,1.164a.576.576,0,0,1-.626-.6,3.616,3.616,0,0,1,1.564-2.543A3.8,3.8,0,0,1,24.128,33.524Z",
    transform: "translate(-11.59 -16.352)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50755",
    "data-name": "Path 50755",
    d: "M16.363,22.657a2.263,2.263,0,0,0-3.1,1.516c-.683,1.987.105,2.928.736,3.137a2.662,2.662,0,0,0,3.573-1.725,2.359,2.359,0,0,0-1.208-2.928Z",
    transform: "translate(-7.772 -12.295)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50756",
    "data-name": "Path 50756",
    d: "M27.338,22.657a2.36,2.36,0,0,0-1.209,2.928A2.663,2.663,0,0,0,29.7,27.31c.63-.209,1.419-1.15.736-3.137a2.263,2.263,0,0,0-3.1-1.516Z",
    transform: "translate(-13.976 -12.295)",
    fill: "#263238"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCallOfDutyHighlighted);
export default __webpack_public_path__ + "static/media/callOfDutyHighlighted.4f423c6e62abd0cb0904613efefb183d.svg";
export { ForwardRef as ReactComponent };